const extractFrom = async (selection) => {
    const context = selection.context;

    selection.inlinePictures.load("items");
    await context.sync();

    const inlineImages = selection.inlinePictures.items;
    const images = [];

    if (inlineImages) {
        for (let i = 0; i < inlineImages.length; i++) {
            const image = inlineImages[i];
            const base64 = image.getBase64ImageSrc();
            image.load("_Id");
            await context.sync();

            images.push({ id: `Picture ${image._Id}`, dataUrl: `data:image/jpg;base64,${base64.value}` });
        }
    }

    return images;
}

export default {
    extractFrom,
}